import React from "react";

function About() {
  return (
    <div className="page about-page">

      {/* PAGE HEADER */}
      <div className="about-header">
        <h1>About Blue Moon Degree College</h1>
        <p>
          Shaping knowledge, character, and careers through quality education
        </p>
      </div>

      {/* ABOUT CONTENT */}
      <div className="about-container">

        {/* INTRO CARD */}
        <div className="about-card">
          <h2>Who We Are</h2>
          <p>
            Blue Moon Degree College is a centre of academic excellence dedicated
            to providing quality higher education with a strong emphasis on
            discipline, values, and holistic student development.
          </p>

          <p>
            Affiliated to Sri Krishnadevaraya University, our institution strives
            to create a learning environment that nurtures intellectual growth,
            ethical responsibility, and professional competence.
          </p>
        </div>

        {/* VISION */}
        <div className="about-card highlight">
          <h2>Our Vision</h2>
          <p>
            To emerge as a leading degree college that empowers students with
            knowledge, skills, and values to succeed in a competitive and
            ever-changing global environment.
          </p>
        </div>

        {/* MISSION */}
        <div className="about-card highlight">
          <h2>Our Mission</h2>
          <ul>
            <li>To provide quality education through experienced faculty</li>
            <li>To promote academic discipline and ethical values</li>
            <li>To encourage innovation, leadership, and critical thinking</li>
            <li>To prepare students for higher studies and career success</li>
          </ul>
        </div>

        {/* WHY CHOOSE US */}
        <div className="about-card">
          <h2>Why Choose Blue Moon Degree College?</h2>

          <div className="why-grid">
            <div className="why-item">🎓 Experienced & Dedicated Faculty</div>
            <div className="why-item">🏫 Modern Infrastructure</div>
            <div className="why-item">📚 Industry-Oriented Curriculum</div>
            <div className="why-item">🧠 Student-Centric Teaching</div>
            <div className="why-item">🌱 Focus on Ethics & Values</div>
            <div className="why-item">🚀 Career & Higher Education Support</div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default About;
